/* File: history.jsx
 * Path: ananunadm/src/helpers/history.jsx
*/
import { createBrowserHistory as history } from "history";

export default history();
